import requests from 'api/index';

const prefixURL = '/employee/empsearch/next';

export default {
  getNoSessionRegister: () =>
    requests.post(`${prefixURL}/rest/v1/nosession/property?noSessionPrc=Y&key=ep.empsearch.register`, {}),
  getNoSessionGlobalPosition: () =>
    requests.post(`${prefixURL}/rest/v1/nosession/property?noSessionPrc=Y&key=ep.global.source.position`, {}),
  getNoSessionDisasterRecoveryMode: () =>
    requests.post(`${prefixURL}/rest/v1/nosession/property?noSessionPrc=Y&key=ep.empsearch.dr`, {}),
};
